;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();export default function Clipboard() {
  return (
    <svg width="132" height="124" viewBox="0 0 132 124" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M40.9607 38.27C27.0498 38.27 15.9111 45.8 15.9111 55.01V85.71"
        stroke="#64358C"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M40.9606 29.9C47.4424 29.9 52.0894 25.34 52.0894 18.74V13.16C52.0894 6.56003 47.4424 2 40.9606 2C34.4788 2 29.8319 6.56003 29.8319 13.16V18.74C29.8319 25.35 34.4788 29.9 40.9606 29.9Z"
        stroke="#64358C"
        strokeWidth="3"
        strokeLinejoin="round"
      />
      <path d="M27.0395 57.8101V85.7201" stroke="#64358C" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M40.9603 38.27C54.8712 38.27 66.0099 45.8 66.0099 55.01V74.54C66.0099 80.7 61.0239 85.7 54.8812 85.7"
        stroke="#64358C"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M54.8714 57.8101V122" stroke="#64358C" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M27.0395 110.83V122" stroke="#64358C" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M43.7425 85.72V122" stroke="#64358C" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M32.614 85.72H2V110.84H32.614V85.72Z" stroke="#64358C" strokeWidth="3" strokeLinejoin="round" />
      <path
        d="M107.743 41.0701L91.0495 57.8101L82.703 49.4401L74.3465 57.8101L91.0495 74.55L116.089 49.4401L107.743 41.0701Z"
        stroke="#E2001A"
        strokeWidth="3"
        strokeLinejoin="round"
      />
      <path
        d="M61.1735 35.51C67.9146 25.4 79.4022 18.74 92.4356 18.74C113.187 18.74 130 35.61 130 56.41C130 77.21 113.177 94.08 92.4356 94.08C83.8597 94.08 75.9619 91.2 69.6397 86.36"
        stroke="#64358C"
        strokeWidth="3"
        strokeLinejoin="round"
      />
    </svg>
  );
}
